<template>
  <el-popover
    ref="popover"
    v-model="visible"
    style="margin:0 20px 0 8px"
    placement="left"
    title="退单消息中心"
    width="600"
    trigger="manual"
    @show="onShow"
    @hide="onHide">
    <div
      v-loading="loading"
      class="user-message-wrap">
      <el-table
        size="mini"
        max-height="330px"
        border=""
        :data="list">
        <el-table-column
          label="订单号"
          min-width="180"
          prop="code"
          :resizable="false">
          <template slot-scope="{row}">
            <link-route :link-to="`/orders-detail?vendorId=${row.parentOwnerCode}&salesOrderId=${row.id}&code=${row.code}`">
              {{ row.code }}
            </link-route>
          </template>
        </el-table-column>
        <el-table-column
          label="收件人"
          min-width="100"
          :resizable="false">
          <template slot-scope="{row}">{{ row.receiverName }}</template>
        </el-table-column>
        <el-table-column
          label="订单来源"
          min-width="80"
          :resizable="false">
          <template slot-scope="{row}">{{ row.source | sourceName() }}</template>
        </el-table-column>
        <el-table-column
          label="订单状态"
          min-width="75"
          :resizable="false">
          <template slot-scope="{row}">{{ row.status | orderStatusName() }}</template>
        </el-table-column>
        <el-table-column
          v-if="hasDepartments"
          label="操作"
          fixed="right"
          width="110">
          <template slot-scope="{row}">
            <el-popconfirm
              title="确认退单吗？"
              @onConfirm="()=> { confirmallreturn(row) }">
              <el-button
                slot="reference"
                type="text">确认退单</el-button>
            </el-popconfirm>
            <el-button
              style="margin-left: 10px"
              type="text"
              @click="copyOrder(row)">复制</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :pager-count="5"
        style="text-align: center;margin-top: 8px"
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange">
      </el-pagination>
      <el-button
        size="mini"
        class="fixed-button"
        @click="visible = false">隐藏</el-button>
    </div>
    <el-badge
      slot="reference"
      :hidden="total === 0"
      :max="99"
      :value="total">
      <i
        class="el-icon-info"
        @click="visible = !visible"></i>
    </el-badge>
  </el-popover>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'UserMessageIcon',
  data() {
    return {
      loading: false,
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        status: 2,
        returnAllConfirm: 0
      },
      total: 0,
      list: [],
      t: null
    }
  },
  computed: {
    ...mapState({
      permmisions: state => state.account.permmisions
    }),
    hasDepartments({ permmisions }) {
      return permmisions.departmentPermissions.length > 0
    }
  },
  mounted() {
    this.fetchList(() => {
      if (this.total > 0) {
        this.visible = true
      }
    })
    this.onHide()
  },
  destroyed() {
    console.log('destroyed')
    clearInterval(this.t)
  },
  methods: {
    onShow() {
      clearInterval(this.t)
    },
    onHide() {
      this.t = setInterval(() => {
        this.fetchList()
      }, 30000)
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('outstock/getsaleslist', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.data.total
          this.list = res.data.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
          this.total = 0
          this.list = []
        }
      })
    },
    copyOrder(row) {
      this.confirmallreturn(row, () => {
        this.$router.push(`/orders-create?salesOrderId=${row.id}&departmentId=${row.ownerCode}`)
      })
    //   this.$router.push(`/orders-create?salesOrderId=${row.id}&departmentId=${row.ownerCode}`)
    },
    confirmallreturn(row, cb) {
      this.loading = true
      this.$store.dispatch('outstock/confirmallreturn', {
        payload: {
          salesOrderId: row.id
        },
        success: () => {
          this.loading = false
          this.handleCurrentChange(1)
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.user-message-wrap {
    position relative
}
.el-icon-info {
    // margin-right 12px;
    cursor pointer
}
.fixed-button {
    position absolute
    right 0
    bottom 2px
}
</style>
